import React, { HtmlHTMLAttributes } from 'react';
import { MenuContext, MenuOptions, useMenu } from './VoxelMenuLogic';

export interface VoxelMenuItemContainerProps extends MenuOptions {
  divProps?: HtmlHTMLAttributes<HTMLElement>;
}

export const VoxelMenuItemContainer: React.FC<VoxelMenuItemContainerProps> = ({
  children,
  divProps = {},
  ...options
}) => {
  const menu = useMenu({ ...options });
  const { className, ...otherDivProps } = divProps;
  return (
    <MenuContext.Provider value={menu}>
      <div className={`p-2 ${className}`} {...otherDivProps}>
        {children}
      </div>
    </MenuContext.Provider>
  );
};

export default VoxelMenuItemContainer;
